import BenchlingConfig from 'BenchlingConfig';
import {ModelHubEnablementState} from 'graphql-client/__generated/graphqlGlobalTypes';

export {ModelHubEnablementState};

export function isScientificAIModelsSectionVisible(): boolean {
  return BenchlingConfig.MODEL_HUB_TAC_PERMISSIONS_ENABLED;
}

export function canRunScientificAIviaTAC(): boolean {
  if (!BenchlingConfig.MODEL_HUB_TAC_PERMISSIONS_ENABLED) {
    return true;
  }
  return BenchlingConfig.MODEL_HUB_SCIENTIFIC_AI_USER_TAC_ENABLED;
}

export function getScientificAIDisabledMessage(): string | null {
  if (canRunScientificAIviaTAC()) {
    return null;
  }
  return 'You do not have permission to run Scientific AI models. Ask your tenant admin for access.';
}

export function canInstallScientificAIModels(): boolean {
  if (!BenchlingConfig.MODEL_HUB_TAC_PERMISSIONS_ENABLED) {
    return false;
  }
  return BenchlingConfig.MODEL_HUB_TENANT_ADMIN_CAN_INSTALL_MODELS;
}

/**
 * Whether the tenant-admin install/uninstall gate is open. Mirrors the backend's
 * MODEL_HUB_TENANT_ADMIN_CAN_INSTALL_MODELS check exactly — independent of the broader enablement state —
 * so UI that gates uninstall lines up with what the API will actually allow.
 */
export function canTenantAdminManageScientificModels(): boolean {
  return BenchlingConfig.MODEL_HUB_TENANT_ADMIN_CAN_INSTALL_MODELS;
}

export function getScientificAIInstallBlockedMessage(): string | null {
  if (canInstallScientificAIModels()) {
    return null;
  }
  if (!BenchlingConfig.MODEL_HUB_TAC_PERMISSIONS_ENABLED) {
    return 'Scientific models are not enabled for this tenant.';
  }
  return 'Model installation is managed by Benchling for this tenant.';
}
